export enum BarChartType {
  BASIC = 'BASIC',
  STACKED = 'stacked'
}
export interface BarChartStudent {
  id: string;
  name: string;
  avatarUrl?: string;
}

export interface BarChartStudentDetail {
  label: string;
  students: BarChartStudent[];
}
export interface BarChartProps {
  type?: BarChartType;
  labels: string[];
  primaryValue: number[];
  secondaryValue?: number[];
  backgroundColor: string[];
  showDataLabel?: boolean;
  isHorizontal?: boolean;
  barThickness?: number;
  dataLabelFontType?: 'mobile' | 'desktop';
  studentDetails?: BarChartStudentDetail[];
}

export interface LineChartProps {
  labels: string[];
  primaryValue: number[];
  secondaryValue: number[];
  primaryColor: string;
  secondaryColor: string;
}

export enum PieChartType {
  PIE = 'pie',
  DONUT = 'donut'
}
export interface PieChartProps {
  label: string[];
  value: number[];
  colors: string[];
  showDataLabel?: boolean;
  chartType?: PieChartType; // Add a new prop to determine chart type
}
